import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router/immutable';
// App settings reducers
import settingReducer from './settingsReducer';
// App auth reducers
import authReducer from './authReducer';
// Entities reducers
import entitiesReducer from './entities';
// Modals reducer
import uiReducer from './ui';
// Redux form reducer
import { reducer as reduxFormReducer } from 'redux-form/immutable';
import { LOGOUT_ACTION_TYPES } from 'helpers/utilHelpers';

const makeAppReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: settingReducer,
    auth: authReducer,
    entities: entitiesReducer,
    ui: uiReducer,
    form: reduxFormReducer,
  });

const makeRootReducer = (history) => {
  const appReducer = makeAppReducer(history);
  return (state, action) => {
    if (LOGOUT_ACTION_TYPES.includes(action.type)) {
      // destroy state after logout
      return appReducer(undefined, action);
    }

    return appReducer(state, action);
  };
};

export default makeRootReducer;
